import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import hi from './locales/hi.json';
import hiEn from './locales/hi-en.json';
import ta from './locales/ta.json';
import te from './locales/te.json';
import bn from './locales/bn.json';
import mr from './locales/mr.json';
import gu from './locales/gu.json';
import pa from './locales/pa.json';
import kn from './locales/kn.json';
import ml from './locales/ml.json';
import or from './locales/or.json';
import as from './locales/as.json';
import sa from './locales/sa.json';
import bho from './locales/bho.json';
import mai from './locales/mai.json';
import ne from './locales/ne.json';
import ks from './locales/ks.json';
import brx from './locales/brx.json';
import mni from './locales/mni.json';
import doi from './locales/doi.json';
import kok from './locales/kok.json';
import sat from './locales/sat.json';
import ur from './locales/ur.json';
import ar from './locales/ar.json';
import fa from './locales/fa.json';
import ru from './locales/ru.json';
import pt from './locales/pt.json';
import tr from './locales/tr.json';
import id from './locales/id.json';
import vi from './locales/vi.json';
import th from './locales/th.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import nl from './locales/nl.json';
import pl from './locales/pl.json';
import uk from './locales/uk.json';
import es from './locales/es.json';
import zh from './locales/zh.json';
import ja from './locales/ja.json';
import ko from './locales/ko.json';

const resources = {
  en: { translation: en },
  hi: { translation: hi },
  'hi-en': { translation: hiEn },
  ta: { translation: ta },
  te: { translation: te },
  bn: { translation: bn },
  mr: { translation: mr },
  gu: { translation: gu },
  pa: { translation: pa },
  kn: { translation: kn },
  ml: { translation: ml },
  or: { translation: or },
  as: { translation: as },
  sa: { translation: sa },
  bho: { translation: bho },
  mai: { translation: mai },
  ne: { translation: ne },
  ks: { translation: ks },
  brx: { translation: brx },
  mni: { translation: mni },
  doi: { translation: doi },
  kok: { translation: kok },
  sat: { translation: sat },
  ur: { translation: ur },
  ar: { translation: ar },
  fa: { translation: fa },
  ru: { translation: ru },
  pt: { translation: pt },
  tr: { translation: tr },
  id: { translation: id },
  vi: { translation: vi },
  th: { translation: th },
  de: { translation: de },
  fr: { translation: fr },
  it: { translation: it },
  nl: { translation: nl },
  pl: { translation: pl },
  uk: { translation: uk },
  es: { translation: es },
  zh: { translation: zh },
  ja: { translation: ja },
  ko: { translation: ko },
};

// RTL Languages (Right-to-Left)
export const RTL_LANGUAGES = ['ar', 'fa', 'ur', 'ks'];

// Available languages with display names and flags
export const AVAILABLE_LANGUAGES = [
  // English
  { code: 'en', name: 'English', nativeName: 'English', flag: '🇺🇸', rtl: false },
  // Indian Languages - Indo-Aryan
  { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी', flag: '🇮🇳', rtl: false },
  { code: 'hi-en', name: 'Hinglish', nativeName: 'हिंग्लिश', flag: '🇮🇳', rtl: false },
  { code: 'mr', name: 'Marathi', nativeName: 'मराठी', flag: '🇮🇳', rtl: false },
  { code: 'gu', name: 'Gujarati', nativeName: 'ગુજરાતી', flag: '🇮🇳', rtl: false },
  { code: 'pa', name: 'Punjabi', nativeName: 'ਪੰਜਾਬੀ', flag: '🇮🇳', rtl: false },
  { code: 'bho', name: 'Bhojpuri', nativeName: 'भोजपुरी', flag: '🇮🇳', rtl: false },
  { code: 'mai', name: 'Maithili', nativeName: 'मैथिली', flag: '🇮🇳', rtl: false },
  { code: 'ne', name: 'Nepali', nativeName: 'नेपाली', flag: '🇳🇵', rtl: false },
  { code: 'sa', name: 'Sanskrit', nativeName: 'संस्कृतम्', flag: '🇮🇳', rtl: false },
  { code: 'doi', name: 'Dogri', nativeName: 'डोगरी', flag: '🇮🇳', rtl: false },
  { code: 'kok', name: 'Konkani', nativeName: 'कोंकणी', flag: '🇮🇳', rtl: false },
  // Indian Languages - Dravidian
  { code: 'ta', name: 'Tamil', nativeName: 'தமிழ்', flag: '🇮🇳', rtl: false },
  { code: 'te', name: 'Telugu', nativeName: 'తెలుగు', flag: '🇮🇳', rtl: false },
  { code: 'kn', name: 'Kannada', nativeName: 'ಕನ್ನಡ', flag: '🇮🇳', rtl: false },
  { code: 'ml', name: 'Malayalam', nativeName: 'മലയാളം', flag: '🇮🇳', rtl: false },
  // Eastern Indian Languages
  { code: 'bn', name: 'Bengali', nativeName: 'বাংলা', flag: '🇮🇳', rtl: false },
  { code: 'or', name: 'Odia', nativeName: 'ଓଡ଼ିଆ', flag: '🇮🇳', rtl: false },
  { code: 'as', name: 'Assamese', nativeName: 'অসমীয়া', flag: '🇮🇳', rtl: false },
  // Northeast Indian Languages
  { code: 'mni', name: 'Manipuri', nativeName: 'মৈতৈলোন্ঠা', flag: '🇮🇳', rtl: false },
  { code: 'brx', name: 'Bodo', nativeName: 'बड़ो', flag: '🇮🇳', rtl: false },
  { code: 'sat', name: 'Santali', nativeName: 'ᱥᱟᱱᱛᱟᱲᱤ', flag: '🇮🇳', rtl: false },
  { code: 'ks', name: 'Kashmiri', nativeName: 'کٲشُر', flag: '🇮🇳', rtl: true },
  // RTL Languages (Right-to-Left)
  { code: 'ur', name: 'Urdu', nativeName: 'اردو', flag: '🇵🇰', rtl: true },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', flag: '🇸🇦', rtl: true },
  { code: 'fa', name: 'Persian/Farsi', nativeName: 'فارسی', flag: '🇮🇷', rtl: true },
  // Slavic Languages
  { code: 'ru', name: 'Russian', nativeName: 'Русский', flag: '🇷🇺', rtl: false },
  // Romance Languages
  { code: 'pt', name: 'Portuguese', nativeName: 'Português', flag: '🇧🇷', rtl: false },
  // Turkic Languages
  { code: 'tr', name: 'Turkish', nativeName: 'Türkçe', flag: '🇹🇷', rtl: false },
  // Austronesian Languages
  { code: 'id', name: 'Indonesian', nativeName: 'Bahasa Indonesia', flag: '🇮🇩', rtl: false },
  // Viet-Muong Languages
  { code: 'vi', name: 'Vietnamese', nativeName: 'Tiếng Việt', flag: '🇻🇳', rtl: false },
  // Kra-Dai Languages
  { code: 'th', name: 'Thai', nativeName: 'ภาษาไทย', flag: '🇹🇭', rtl: false },
  // Germanic Languages
  { code: 'de', name: 'German', nativeName: 'Deutsch', flag: '🇩🇪', rtl: false },
  // Romance Languages
  { code: 'fr', name: 'French', nativeName: 'Français', flag: '🇫🇷', rtl: false },
  { code: 'it', name: 'Italian', nativeName: 'Italiano', flag: '🇮🇹', rtl: false },
  { code: 'nl', name: 'Dutch', nativeName: 'Nederlands', flag: '🇳🇱', rtl: false },
  // Slavic Languages
  { code: 'pl', name: 'Polish', nativeName: 'Polski', flag: '🇵🇱', rtl: false },
  { code: 'uk', name: 'Ukrainian', nativeName: 'Українська', flag: '🇺🇦', rtl: false },
  // International Languages
  { code: 'es', name: 'Spanish', nativeName: 'Español', flag: '🇪🇸', rtl: false },
  { code: 'zh', name: 'Chinese', nativeName: '中文', flag: '🇨🇳', rtl: false },
  { code: 'ja', name: 'Japanese', nativeName: '日本語', flag: '🇯🇵', rtl: false },
  { code: 'ko', name: 'Korean', nativeName: '한국어', flag: '🇰🇷', rtl: false },
];

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // Order of language detection (first found wins)
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Cache the language choice
      caches: ['localStorage'],
      // Keys to check
      lookupLocalStorage: 'i18nextLng',
      lookupFromPathIndex: 0,
    },
  });

export default i18n;
